import { render, staticRenderFns } from "./MtipoimplicadoModals.vue?vue&type=template&id=01de4614"
import script from "./MtipoimplicadoModals.vue?vue&type=script&lang=js"
export * from "./MtipoimplicadoModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports